module.exports = __webpack_public_path__ + "img/ling.3c011350.png";